module.exports = __webpack_public_path__ + "static/media/img_adm_module5.dd36b7f0.png";